@if (dealer().hasSales) {
    <a
        [trackingElTarget]="dealer().pages.testDriveForm"
        [hyundaiRouterLink]="dealer().pages.testDriveForm"
        trackingElLabel="Test Drive"
        trackingElType="button"
        trackingEvent="engagement_click"
        tracking
    >
        <span class="inline-block font-headline text-16 text-accent md:hidden">Probefahrt</span>
        <span class="md:inverted hidden md:button-secondary md:inline-block md:bg-transparent">Probefahrt</span>
    </a>
}
@if (dealer().hasService && dealer().hasSales) {
    <div class="my-auto h-[23px] w-1 bg-grey-400 md:hidden"></div>
}
@if (dealer().hasService) {
    <a
        [trackingElTarget]="dealerServiceMailLink()"
        [hyundaiRouterLink]="dealerServiceMailLink()"
        trackingElType="button"
        trackingEvent="engagement_click"
        tracking
        trackingElLabel="Service Request"
    >
        <span class="inline-block font-headline text-16 text-accent md:hidden">Servicetermin</span>
        <span class="button-primary hidden md:inline-flex">Servicetermin</span>
    </a>
}
